import Page from "@jumbo/shared/Page";
import { lazy } from "react";
import expensesRouter from "./Master/Expenses";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";

// Constants – keep eagerly loaded
import {
  CHARACTER_MASTER,
  CHARACTER_MASTER_ADD,
  CHARACTER_MASTER_EDIT,
  COLOUR_MASTER,
  COLOUR_MASTER_ADD,
  COLOUR_MASTER_EDIT,
  CUSTOMER_MASTER,
  CUSTOMER_MASTER_ADD,
  CUSTOMER_MASTER_EDIT,
  CUSTOMER_MASTER_VIEW,
  DISPATCH_ADDRESS_MASTER,
  DISPATCH_ADDRESS_MASTER_ADD,
  DISPATCH_ADDRESS_MASTER_EDIT,
  PATTERN_MASTER,
  PATTERN_MASTER_ADD,
  PATTERN_MASTER_EDIT,
  PHOTO_MASTER,
  PHOTO_MASTER_ADD,
  PHOTO_MASTER_EDIT,
  PHOTO_MASTER_VIEW_DETAILS,
  POLISH_MASTER,
  POLISH_MASTER_ADD,
  POLISH_MASTER_EDIT,
  POLISH_MASTER_VIEW_DETAILS,
  PROCESS_MASTER,
  PROCESS_MASTER_ADD,
  PROCESS_MASTER_EDIT,
  TRANSPORTER_MASTER,
  TRANSPORTER_MASTER_ADD,
  TRANSPORTER_MASTER_EDIT,
  VEHICLE_MASTER,
  VEHICLE_MASTER_ADD,
  VEHICLE_MASTER_EDIT,
} from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy imports
const AddCurrency = lazy(() => import("app/pages/Master/CurrencyMaster/AddCurrency"));
const ListCurrency = lazy(() => import("app/pages/Master/CurrencyMaster/ListCurrency"));
const AddCut = lazy(() => import("app/pages/Master/CutMaster/AddCut"));
const ListCut = lazy(() => import("app/pages/Master/CutMaster/ListCut"));
const AddDepartment = lazy(() => import("app/pages/Master/DepartmentMaster/AddDepartment"));
const EditDepartment = lazy(() => import("app/pages/Master/DepartmentMaster/EditDepartment"));
const ListDepartment = lazy(() => import("app/pages/Master/DepartmentMaster/ListDepartment"));
const AddExpenseType = lazy(() => import("app/pages/Master/ExpenseTypeMaster/AddExpenseType"));
const ListExpenseType = lazy(() => import("app/pages/Master/ExpenseTypeMaster/ListExpenseType"));
const AddGrade = lazy(() => import("app/pages/Master/GradeMaster/AddGrade"));
const ListGrade = lazy(() => import("app/pages/Master/GradeMaster/ListGrade"));
const AddGst = lazy(() => import("app/pages/Master/GstMaster/AddGst"));
const ListGst = lazy(() => import("app/pages/Master/GstMaster/ListGst"));
const AddItemPage = lazy(() => import("app/pages/Master/ItemCategory/AddItem/AddItemPage"));
const EditCatgeoryPage = lazy(() => import("app/pages/Master/ItemCategory/EditCategory/EditCatgeoryPage"));
const Main = lazy(() => import("app/pages/Master/ItemCategory/Main"));
const AddItemCode = lazy(() => import("app/pages/Master/ItemCodeMaster/AddItemCode"));
const ListItemCode = lazy(() => import("app/pages/Master/ItemCodeMaster/ListItemCode"));
const AddItemName = lazy(() => import("app/pages/Master/ItemNameMaster/AddItemName"));
const ListItemName = lazy(() => import("app/pages/Master/ItemNameMaster/ListItemName"));
const AddSubcategoryPage = lazy(() => import("app/pages/Master/ItemSubCategory/AddSubcategory/AddSubcategoryPage"));
const EditSubCategorypage = lazy(() => import("app/pages/Master/ItemSubCategory/EditSubCategory/EditSubCategorypage"));
const Subcategory = lazy(() => import("app/pages/Master/ItemSubCategory/SubCategory"));
const AddMachinePage = lazy(() => import("app/pages/Master/MachineMaster/AddMachine/AddMachinePage"));
const Machine = lazy(() => import("app/pages/Master/MachineMaster/Machine"));
const AddPallet = lazy(() => import("app/pages/Master/PalletMaster/AddPallet"));
const ListPallet = lazy(() => import("app/pages/Master/PalletMaster/ListPallet"));
const AddParty = lazy(() => import("app/pages/Master/PartyMaster/AddParty"));
const ListParty = lazy(() => import("app/pages/Master/PartyMaster/ListParty"));
const AddSeries = lazy(() => import("app/pages/Master/SeriesMaster/AddSeries/AddSeries"));
const Series = lazy(() => import("app/pages/Master/SeriesMaster/Series"));
const AddSupplier = lazy(() => import("app/pages/Master/SupplierMaster/AddSupplier"));
const AddBranches = lazy(() => import("app/pages/Master/SupplierMaster/Branches/AddBranches"));
const ListBranches = lazy(() => import("app/pages/Master/SupplierMaster/Branches/ListBranches"));
const EditSupplierPage = lazy(() => import("app/pages/Master/SupplierMaster/EditSupplier/EditSupplierPage"));
const ListSupplier = lazy(() => import("app/pages/Master/SupplierMaster/ListSupplier"));
const ContactPersonList = lazy(() => import("app/pages/Master/SupplierMaster/ListSupplier/ContactPersonList"));
const AddUnit = lazy(() => import("app/pages/Master/UnitMaster/AddUnit"));
const ListUnit = lazy(() => import("app/pages/Master/UnitMaster/ListUnit"));
const Character = lazy(() => import("app/pages/Master/CharacterMaster/Character"));
const AddCharacterPage = lazy(() => import("app/pages/Master/CharacterMaster/AddCharacter/AddCharacterPage"));
const Pattern = lazy(() => import("app/pages/Master/PatternMaster/Pattern"));
const AddPatternPage = lazy(() => import("app/pages/Master/PatternMaster/AddPattern/AddPatternPage"));
const Process = lazy(() => import("app/pages/Master/ProcessMaster/Process"));
const AddProcessPage = lazy(() => import("app/pages/Master/ProcessMaster/AddProcess/AddProcessPage"));
const Colour = lazy(() => import("app/pages/Master/ColourMaster/Colour"));
const AddColourPage = lazy(() => import("app/pages/Master/ColourMaster/AddColour/AddColourPage"));
const Transporter = lazy(() => import("app/pages/Master/TransporterMaster/Transporter"));
const AddTransporterPage = lazy(() => import("app/pages/Master/TransporterMaster/AddTransporter/AddTransporterPage"));
const Vehicle = lazy(() => import("app/pages/Master/VehicleMaster/Vehicle"));
const AddVehiclePage = lazy(() => import("app/pages/Master/VehicleMaster/AddVehicle/AddVehiclePage"));
const DispatchAddress = lazy(() => import("app/pages/Master/DispatchAddressMaster/DispatchAddress"));
const AddDispatchAddressPage = lazy(() => import("app/pages/Master/DispatchAddressMaster/AddDispatchAddress/AddDispatchAddressPage"));
const PhotoMasterMain = lazy(() => import("app/pages/Master/PhotoMaster/ListPhoto"));
const AddPhotoPage = lazy(() => import("app/pages/Master/PhotoMaster/AddPhoto/AddPhotoPage"));
const ViewPhoto = lazy(() => import("app/pages/Master/PhotoMaster/ListPhoto/PhotoMasterListing/ViewPhotoDetails"));
const AddPolishPage = lazy(() => import("app/pages/Master/PolishMaster/AddPolish/AddPolishPage"));
const Polish = lazy(() => import("app/pages/Master/PolishMaster/Polish.jsx"));
const ViewPolish = lazy(() => import("app/pages/Master/PolishMaster/ViewPolish/ViewPolish"));
const Customer = lazy(() => import("app/pages/Master/CustomerMaster/Customer"));
const ViewCustomer = lazy(() => import("app/pages/Master/CustomerMaster/ViewCustomer/ViewCustomer"));
const AddCustomerPage = lazy(() => import("app/pages/Master/CustomerMaster/AddCustomer/AddCustomerPage"));
const SizeMasterList = lazy(() => import("app/pages/Master/SizeMaster"));

export const masterRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "supplier_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/supplier",
        element: LoadablePage(ListSupplier),
      },
      {
        path: "/master/supplier/add",
        element: LoadablePage(AddSupplier),
      },
      {
        path: "/master/supplier/edit",
        element: LoadablePage(AddSupplier),
      },
      {
        path: "/master/supplier/branch/add/:id",
        element: LoadablePage(AddBranches),
      },
      {
        path: "/master/supplier/branch/list/:id",
        element: LoadablePage(ListBranches),
      },
      {
        path: "/master/supplier/edit/:id",
        element: LoadablePage(EditSupplierPage),
      },
      {
        path: "/master/supplier/contact-person-list",
        element: LoadablePage(ContactPersonList),
      },
    ],
  },

  //item-category

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "item_category_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/item-category/list",
        element: LoadablePage(Main),
      },
      {
        path: "/master/item-category/add",
        element: LoadablePage(AddItemPage),
      },
      {
        path: "/master/item-category/edit/:id",
        element: LoadablePage(EditCatgeoryPage),
      },
    ],
  },

  //item-sub-category

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "item_sub_category_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/item-subcategory/list",
        element: LoadablePage(Subcategory),
      },
      {
        path: "/master/item-subcategory/add",
        element: LoadablePage(AddSubcategoryPage),
      },
      {
        path: "/master/item-subcategory/edit/:id",
        element: LoadablePage(EditSubCategorypage),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "pallet_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/pallet",
        element: LoadablePage(ListPallet),
      },
      {
        path: "/master/pallet/add",
        element: LoadablePage(AddPallet),
      },
      {
        path: "/master/pallet/edit",
        element: LoadablePage(AddPallet),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "size_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/size",
        element: LoadablePage(SizeMasterList),
      },
      {
        path: "/master/size/add",
        element: LoadablePage(AddUnit),
      },
      {
        path: "/master/size/edit",
        element: LoadablePage(AddUnit),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "unit_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/unit",
        element: LoadablePage(ListUnit),
      },
      {
        path: "/master/unit/add",
        element: LoadablePage(AddUnit),
      },
      {
        path: "/master/unit/edit",
        element: LoadablePage(AddUnit),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "grade_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/grade",
        element: LoadablePage(ListGrade),
      },
      {
        path: "/master/grade/add",
        element: LoadablePage(AddGrade),
      },
      {
        path: "/master/grade/edit",
        element: LoadablePage(AddGrade),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "currency_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/currency",
        element: LoadablePage(ListCurrency),
      },
      {
        path: "/master/currency/add",
        element: LoadablePage(AddCurrency),
      },
      {
        path: "/master/currency/edit",
        element: LoadablePage(AddCurrency),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "cut_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/cut",
        element: LoadablePage(ListCut),
      },
      {
        path: "/master/cut/add",
        element: LoadablePage(AddCut),
      },
      {
        path: "/master/cut/edit",
        element: LoadablePage(AddCut),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "gst_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/gst",
        element: LoadablePage(ListGst),
      },
      {
        path: "/master/gst/add",
        element: LoadablePage(AddGst),
      },
      {
        path: "/master/gst/edit",
        element: LoadablePage(AddGst),
      },
    ],
  },
  ...expensesRouter,
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_type_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expenseType",
        element: LoadablePage(ListExpenseType),
      },
      {
        path: "/master/expenseType/add",
        element: LoadablePage(AddExpenseType),
      },
      {
        path: "/master/expenseType/edit",
        element: LoadablePage(AddExpenseType),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "party_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/party",
        element: LoadablePage(ListParty),
      },
      {
        path: "/master/party/add",
        element: LoadablePage(AddParty),
      },
      {
        path: "/master/party/edit",
        element: LoadablePage(AddParty),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "item_name_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/item-name",
        element: LoadablePage(ListItemName),
      },
      {
        path: "/master/item-name/add",
        element: LoadablePage(AddItemName),
      },
      {
        path: "/master/item-name/edit",
        element: LoadablePage(AddItemName),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "item_code_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/item-code",
        element: LoadablePage(ListItemCode),
      },
      {
        path: "/master/item-code/add",
        element: LoadablePage(AddItemCode),
      },
      {
        path: "/master/item-code/edit",
        element: LoadablePage(AddItemCode),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "series_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/series",
        element: LoadablePage(Series),
      },
      {
        path: "/master/series/add",
        element: LoadablePage(AddSeries),
      },
      {
        path: "/master/series/edit",
        element: LoadablePage(AddSeries),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "department_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/department",
        element: LoadablePage(ListDepartment),
      },
      {
        path: "/master/department/add",
        element: LoadablePage(AddDepartment),
      },
      {
        path: "/master/department/edit",
        element: LoadablePage(EditDepartment),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "machine_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/machine",
        element: LoadablePage(Machine),
      },
      {
        path: "/master/machine/add",
        element: LoadablePage(AddMachinePage),
      },
      {
        path: "/master/machine/edit",
        element: LoadablePage(AddMachinePage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "character_master", "view"],
      },
    ],
    routes: [
      {
        path: CHARACTER_MASTER,
        element: LoadablePage(Character),
      },
      {
        path: CHARACTER_MASTER_ADD,
        element: LoadablePage(AddCharacterPage),
      },
      {
        path: CHARACTER_MASTER_EDIT,
        element: LoadablePage(AddCharacterPage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "pattern_master", "view"],
      },
    ],
    routes: [
      {
        path: PATTERN_MASTER,
        element: LoadablePage(Pattern),
      },
      {
        path: PATTERN_MASTER_ADD,
        element: LoadablePage(AddPatternPage),
      },
      {
        path: PATTERN_MASTER_EDIT,
        element: LoadablePage(AddPatternPage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "process_master", "view"],
      },
    ],
    routes: [
      {
        path: PROCESS_MASTER,
        element: LoadablePage(Process),
      },
      {
        path: PROCESS_MASTER_ADD,
        element: LoadablePage(AddProcessPage),
      },
      {
        path: PROCESS_MASTER_EDIT,
        element: LoadablePage(AddProcessPage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "colour_master", "view"],
      },
    ],
    routes: [
      {
        path: COLOUR_MASTER,
        element: LoadablePage(Colour),
      },
      {
        path: COLOUR_MASTER_ADD,
        element: LoadablePage(AddColourPage),
      },
      {
        path: COLOUR_MASTER_EDIT,
        element: LoadablePage(AddColourPage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "transporter_master", "view"],
      },
    ],
    routes: [
      {
        path: TRANSPORTER_MASTER,
        element: LoadablePage(Transporter),
      },
      {
        path: TRANSPORTER_MASTER_ADD,
        element: LoadablePage(AddTransporterPage),
      },
      {
        path: TRANSPORTER_MASTER_EDIT,
        element: LoadablePage(AddTransporterPage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "vehicle_master", "view"],
      },
    ],
    routes: [
      {
        path: VEHICLE_MASTER,
        element: LoadablePage(Vehicle),
      },
      {
        path: VEHICLE_MASTER_ADD,
        element: LoadablePage(AddVehiclePage),
      },
      {
        path: VEHICLE_MASTER_EDIT,
        element: LoadablePage(AddVehiclePage),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "dispatch_address_master", "view"],
      },
    ],
    routes: [
      {
        path: DISPATCH_ADDRESS_MASTER,
        element: LoadablePage(DispatchAddress),
      },
      {
        path: DISPATCH_ADDRESS_MASTER_ADD,
        element: LoadablePage(AddDispatchAddressPage),
      },
      {
        path: DISPATCH_ADDRESS_MASTER_EDIT,
        element: LoadablePage(AddDispatchAddressPage),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "photo_master", "view"],
      },
    ],
    routes: [
      {
        path: PHOTO_MASTER,
        element: LoadablePage(PhotoMasterMain),
      },
      {
        path: PHOTO_MASTER_ADD,
        element: LoadablePage(AddPhotoPage),
      },
      {
        path: PHOTO_MASTER_EDIT,
        element: LoadablePage(AddPhotoPage),
      },
      {
        path: PHOTO_MASTER_VIEW_DETAILS,
        element: LoadablePage(ViewPhoto),
      },
    ],
  },

  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "polish_master", "view"],
      },
    ],
    routes: [
      {
        path: POLISH_MASTER,
        element: LoadablePage(Polish),
      },
      {
        path: POLISH_MASTER_ADD,
        element: LoadablePage(AddPolishPage),
      },
      {
        path: POLISH_MASTER_EDIT,
        element: LoadablePage(AddPolishPage),
      },
      {
        path: POLISH_MASTER_VIEW_DETAILS,
        element: LoadablePage(ViewPolish),
      },
    ],
  },
  //================================
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "customer_master", "view"],
      },
    ],
    routes: [
      {
        path: CUSTOMER_MASTER,
        element: LoadablePage(Customer),
      },
      {
        path: CUSTOMER_MASTER_VIEW,
        element: LoadablePage(ViewCustomer),
      },
      {
        path: CUSTOMER_MASTER_ADD,
        element: LoadablePage(AddCustomerPage),
      },
      {
        path: CUSTOMER_MASTER_EDIT,
        element: LoadablePage(AddCustomerPage),
      },
    ],
  },
];
